import { FC, memo } from "react";
import { MatchStatus } from "service";
import styled from "styled-components";
import { SIDE } from "_constants";
import { getTeamColors } from "components/colors";
import { isTwoPointCode } from "../constants";

export const TwoPointsIndicator: FC<{ status: MatchStatus }> = memo(
  ({ status: { nsc, side, ...status } }) => {
    const isTwoPoints = isTwoPointCode(nsc);

    const { home, away } = getTeamColors(status as any);
    const fillColor = side === SIDE.HOME ? home : away;

    if (!isTwoPoints) return null;

    const PATH_D =
      "M-0.5 -4.57764e-05H35.5C35.5 -4.57764e-05 69.3667 1.99996 88 15C106.633 28 121.5 42.9999 121.5 68.4999C121.5 94 108.5 110 87 123C65.5 136 35.5 137 35.5 137H-0.5V-4.57764e-05Z";

    return (
      <PathContainer className="two-points-indicator">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 400 180"
          preserveAspectRatio="none"
        >
          <path
            d={PATH_D}
            fill={fillColor}
            opacity={0.5}
            transform={
              String(side) === String(SIDE.HOME)
                ? "translate(400 21.5) scale(-1 1)"
                : "translate(0 21.5)"
            }
          />
        </svg>
      </PathContainer>
    );
  }
);

const PathContainer = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  padding: 1vw;

  & > svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
